import { j as a, c as n } from "../../utils-BdNIfrGQ.js";
import { S as m } from "../../index-5pXbvMI7.js";
import { c as l } from "../../index-Di82Y7n3.js";
import "../../separator-CQVuQllV.js";
import { S as c } from "../../skeleton-CpjuZTJp.js";
import { X as d } from "../../x-BXShoIAM.js";
import { n as u } from "../../normalize-spacing-DY0KSpr_.js";
import { n as p } from "../../normalize-gap-CHOQjV8I.js";
function f({ className: e, ...t }) {
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      role: "list",
      "data-slot": "item-group",
      className: n("group/item-group flex flex-col", e),
      ...t
    }
  );
}
const x = l(
  "group/item flex items-center border border-transparent text-sm rounded-md transition-colors [a]:hover:bg-accent/50 [a]:transition-colors duration-100 flex-wrap outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border-border",
        muted: "bg-muted/50"
      },
      size: {
        default: "p-4 gap-4 ",
        sm: "py-3 px-4 gap-2.5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function g({
  className: e,
  variant: t = "default",
  size: r = "default",
  asChild: s = !1,
  ...o
}) {
  const i = s ? m : "div";
  return /* @__PURE__ */ a.jsx(
    i,
    {
      "data-slot": "item",
      "data-variant": t,
      "data-size": r,
      className: n(x({ variant: t, size: r, className: e })),
      ...o
    }
  );
}
const b = ({ ...e }) => /* @__PURE__ */ a.jsx(g, { ...e }), h = ({
  size: e = "default",
  className: t,
  ...r
}) => /* @__PURE__ */ a.jsx(
  c,
  {
    className: n("rounded-md w-full block", e === "sm" ? "h-[44px]" : "h-[56px]", t),
    ...r
  }
);
h.displayName = "ItemSkeleton";
const v = l(
  "inline-flex items-center rounded-[8px] py-2 px-4 h-fit text-sm w-fit border border-border hover:bg-accent hover:text-accent-foreground",
  {
    variants: {
      accent: {
        primary: "border-primary text-primary",
        light: "bg-white/50 text-black"
      }
    }
  }
), w = ({
  accent: e,
  label: t,
  dismissIcon: r = !0,
  ...s
}) => {
  const o = r ? /* @__PURE__ */ a.jsx(d, { size: 10, "aria-hidden": !0 }) : null;
  return /* @__PURE__ */ a.jsx(b, { className: n(v({ accent: e })), asChild: !0, children: /* @__PURE__ */ a.jsxs(
    "button",
    {
      className: "inline-flex items-center focus:bg-accent focus:text-accent-foreground",
      ...s,
      children: [
        t,
        o
      ]
    }
  ) });
}, G = ({ spacing: e, gap: t, className: r, ...s }) => {
  const o = u(e), i = p(t);
  return /* @__PURE__ */ a.jsx(f, { className: n(r, o, i), ...s });
};
export {
  b as Item,
  w as ItemChip,
  G as ItemGroup,
  h as ItemSkeleton
};
